import {TicketUseResultVo} from '../../common/shared/api/nicolas/vo/TicketUseResultVo.interface';
import {TicketUseMutationPayload} from '../generated/types';

export function createTicketUseMutationPayload({
  waitfree_charged_at,
  ticket_uid,
}: TicketUseResultVo): TicketUseMutationPayload {
  return {
    waitfreeChargedAt: waitfree_charged_at,
    ticketUid: ticket_uid ? BigInt(ticket_uid).toString() : undefined,
  };
}
